var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFlipkartPremium = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 16,
    viewBox: "0 0 149 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_6411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2861 4.56522C11.2861 4.56522 13.2328 5.50998 14.1932 5.91097C15.1275 6.30022 15.2334 7.75945 14.2051 8.25232C13.1768 8.74527 12.8934 8.82549 12.8934 8.82549C12.8934 8.82549 13.0551 8.41669 13.0331 8.02156C12.9672 7.31734 10.8428 6.7462 9.43521 6.40781C9.43521 6.40781 8.35504 3.08646 7.86587 2.16126C7.37472 1.23019 6.37842 0.844849 6.37842 0.844849L8.73245 0.876143C8.73245 0.876143 9.54301 0.837023 9.9024 1.68985C10.2618 2.54072 11.2861 4.56522 11.2861 4.56522Z",
    fill: "url(#paint0_linear_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1503 11.8403C11.1503 11.8403 10.196 13.7259 9.77671 14.6902C9.37739 15.6057 7.85796 15.7093 7.35682 14.702C6.85367 13.6946 6.80176 13.5146 6.80176 13.5146C6.80176 13.5146 7.10525 13.5733 7.58842 13.5518C8.30719 13.4873 8.92413 11.406 9.26959 10.027C9.26959 10.027 12.6598 8.9669 13.6042 8.48959C14.5546 8.00843 14.9479 7.03235 14.9479 7.03235L14.916 9.68276C14.916 9.68276 14.9559 10.1346 14.0874 10.4867C13.2169 10.8388 11.1503 11.8403 11.1503 11.8403Z",
    fill: "url(#paint1_linear_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65903 11.7018C3.65903 11.7018 1.72233 10.7629 0.749973 10.3561C-0.184437 9.96674 -0.290257 8.50558 0.737996 8.01467C1.76625 7.52173 2.17955 7.43176 2.17955 7.43176C2.17955 7.43176 1.912 7.85031 1.97789 8.32173C2.04577 9.02791 4.10228 9.52078 5.5059 9.85918C5.5059 9.85918 6.62799 13.161 7.07522 14.1057C7.62229 15.2559 8.52873 15.4319 8.52873 15.4319L5.85929 15.3928C5.85929 15.3928 5.39808 15.4319 5.03868 14.5811C4.68329 13.7262 3.65903 11.7018 3.65903 11.7018Z",
    fill: "url(#paint2_linear_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81751 4.41732C3.81751 4.41732 4.77588 2.52193 5.19118 1.56738C5.5885 0.651957 7.07797 0.550243 7.58112 1.55564C8.08429 2.563 8.1322 2.74492 8.1322 2.74492C8.1322 2.74492 7.75284 2.75078 7.3515 2.7723C6.63073 2.8388 6.04373 4.85352 5.70032 6.23057C5.70032 6.23057 2.32205 7.31224 1.36567 7.76802C0.0499144 8.39391 0 9.19595 0 9.19595L0.0539123 6.57679C0.0539123 6.57679 0.0139789 6.12494 0.882505 5.77285C1.75103 5.42077 3.81751 4.41732 3.81751 4.41732Z",
    fill: "url(#paint3_linear_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.163 15.2117H18.8228L21.1179 1.06824H27.0608C28.8778 1.06824 30.1552 1.39499 30.8929 2.04848C31.6443 2.70198 32.02 3.6222 32.02 4.80916C32.02 5.40931 31.9654 5.96945 31.8561 6.48958C31.7468 6.99637 31.5418 7.51651 31.2413 8.04996C30.9544 8.57011 30.5719 9.01687 30.0937 9.39032C29.6292 9.7504 29.0076 10.0505 28.2289 10.2905C27.4502 10.5172 26.5485 10.6306 25.5239 10.6306H22.9213L22.163 15.2117ZM23.3311 8.04996H25.6468C27.5868 8.04996 28.5568 7.14974 28.5568 5.34929C28.5568 4.78915 28.3928 4.36905 28.0649 4.08899C27.7371 3.79558 27.1701 3.64888 26.364 3.64888H24.0484L23.3311 8.04996Z",
    fill: "url(#paint4_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5854 12.631L37.3395 14.9916C36.5881 15.285 35.8162 15.4317 35.0238 15.4317C34.1359 15.4317 33.4528 15.2316 32.9746 14.8315C32.5101 14.4315 32.2778 13.8579 32.2778 13.1111C32.2778 12.911 32.2983 12.691 32.3393 12.4509L34.2452 0.588013H37.442L35.6591 11.6707C35.6455 11.8308 35.6386 11.9442 35.6386 12.0108C35.6386 12.3309 35.6933 12.5443 35.8026 12.651C35.9255 12.7577 36.1646 12.811 36.5198 12.811C36.8067 12.811 37.1619 12.751 37.5854 12.631Z",
    fill: "url(#paint5_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.191 4.66907L48.4697 15.2116H45.9696L46.0516 12.9711C44.9176 14.6115 43.4626 15.4317 41.6866 15.4317C40.7303 15.4317 40.0131 15.1716 39.5349 14.6515C39.0567 14.1314 38.8176 13.4379 38.8176 12.571C38.8176 12.2109 38.845 11.8908 38.8997 11.6108L40.0472 4.66907H43.2236L42.2194 10.8306C42.1785 11.0306 42.158 11.244 42.158 11.4708C42.158 12.2576 42.4448 12.6511 43.0186 12.6511C43.4695 12.6511 43.975 12.4043 44.5351 11.9109C45.0952 11.4174 45.6212 10.7972 46.113 10.0504L46.9942 4.66907H50.191Z",
    fill: "url(#paint6_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4751 14.9115L51.0284 12.3109C51.124 12.4176 51.5544 12.551 52.3194 12.711C53.0845 12.8577 53.8017 12.9311 54.4711 12.9311C55.8509 12.9311 56.5409 12.5976 56.5409 11.9308C56.5409 11.6907 56.3633 11.4974 56.0081 11.3507C55.6666 11.204 55.243 11.084 54.7375 10.9906C54.2457 10.8839 53.7471 10.7505 53.2416 10.5905C52.7497 10.4171 52.3263 10.1304 51.9711 9.7303C51.6295 9.31684 51.4587 8.7967 51.4587 8.16986C51.4587 6.96959 51.9027 6.04937 52.7907 5.40921C53.6787 4.76905 55.0176 4.44897 56.8073 4.44897C57.3947 4.44897 57.9685 4.48898 58.5287 4.569C59.0888 4.63569 59.5123 4.70904 59.7992 4.78905C60.0998 4.86908 60.2911 4.93576 60.373 4.98911L59.8402 7.50972C59.608 7.36303 59.1844 7.23633 58.5697 7.12964C57.9549 7.02295 57.3606 6.96959 56.7868 6.96959C55.3659 6.96959 54.6556 7.28964 54.6556 7.92986C54.6556 8.15655 54.8263 8.33663 55.1679 8.46993C55.5231 8.60332 55.9466 8.72339 56.4385 8.83008C56.9302 8.92339 57.4221 9.05677 57.9139 9.23015C58.4194 9.39023 58.8429 9.67692 59.1844 10.0904C59.5397 10.4904 59.7173 11.0039 59.7173 11.6307C59.7173 12.9244 59.2391 13.8779 58.2828 14.4915C57.3401 15.1049 56.0423 15.4117 54.3892 15.4117C53.7607 15.4117 53.1254 15.3717 52.4833 15.2917C51.8413 15.2116 51.3563 15.1383 51.0284 15.0716C50.7142 14.9916 50.5297 14.9382 50.4751 14.9115Z",
    fill: "url(#paint7_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4966 15.1979H64.2483L66.4802 1.44373H72.2596C74.0266 1.44373 75.2689 1.76149 75.9863 2.39699C76.7171 3.0325 77.0822 3.9274 77.0822 5.08169C77.0822 5.66533 77.0293 6.21005 76.9228 6.71586C76.8162 7.2087 76.6173 7.71453 76.3253 8.23329C76.0459 8.73911 75.6741 9.17358 75.2093 9.53671C74.757 9.88689 74.1528 10.1787 73.3955 10.4122C72.6382 10.6326 71.7613 10.7429 70.7649 10.7429H68.234L67.4966 15.1979ZM68.6325 8.23329H70.8844C72.771 8.23329 73.7143 7.35787 73.7143 5.60696C73.7143 5.06223 73.5549 4.6537 73.236 4.38133C72.9172 4.096 72.3658 3.95334 71.582 3.95334H69.33L68.6325 8.23329Z",
    fill: "url(#paint8_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9346 15.1982L78.5885 4.94581H81.0395L80.9196 7.4165C81.9961 5.62671 83.3378 4.73181 84.9456 4.73181H85.1251L84.5269 7.82508C83.8497 7.82508 83.1784 8.03257 82.5139 8.44762C81.8501 8.84966 81.3055 9.34246 80.8801 9.9261L80.0435 15.1982H76.9346Z",
    fill: "url(#paint9_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2587 7.82499C95.1522 10.2114 93.3255 11.4045 89.7785 11.4045C89.2734 11.4045 88.7817 11.3851 88.3034 11.3462C88.3705 11.9428 88.5828 12.3708 88.9412 12.6301C89.3137 12.8896 89.9447 13.0192 90.8349 13.0192C91.8846 13.0192 92.9671 12.8312 94.0831 12.4551L93.6048 14.9258C92.4888 15.263 91.2931 15.4316 90.0177 15.4316C88.2371 15.4316 86.9684 15.062 86.2115 14.3227C85.4672 13.5835 85.0955 12.5134 85.0955 11.1128C85.0955 9.32295 85.6401 7.81844 86.7292 6.59934C87.8318 5.3802 89.3136 4.77063 91.1732 4.77063C92.5686 4.77063 93.5981 5.04947 94.2627 5.60717C94.9265 6.15189 95.2587 6.89115 95.2587 7.82499ZM88.4629 9.43968C88.5962 9.46564 88.8085 9.47859 89.1006 9.47859C91.1337 9.47859 92.1499 9.01815 92.1499 8.09735C92.1499 7.79902 92.05 7.5591 91.8511 7.3775C91.6515 7.18296 91.3527 7.0857 90.9541 7.0857C90.3164 7.0857 89.7852 7.2932 89.3598 7.70826C88.9479 8.12324 88.6491 8.7004 88.4629 9.43968Z",
    fill: "url(#paint10_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.771 4.73181C111.701 4.73181 112.398 4.98471 112.863 5.49053C113.329 5.99634 113.561 6.67076 113.561 7.5138C113.561 7.86399 113.534 8.17526 113.481 8.44762L112.365 15.1982H109.276L110.252 9.20631C110.293 9.01177 110.312 8.80428 110.312 8.58377C110.312 7.81853 110.033 7.43599 109.475 7.43599C108.705 7.43599 107.768 8.2725 106.665 9.94559L105.809 15.1982H102.72L103.696 9.20631C103.736 9.01177 103.756 8.80428 103.756 8.58377C103.756 7.81853 103.477 7.43599 102.919 7.43599C102.148 7.43599 101.205 8.27897 100.089 9.965L99.2324 15.1982H96.1235L97.7976 4.94581H100.228L100.129 7.1247C100.687 6.32058 101.278 5.72398 101.903 5.3349C102.54 4.93284 103.311 4.73181 104.214 4.73181C105.768 4.73181 106.679 5.4192 106.945 6.79397C107.954 5.4192 109.23 4.73181 110.771 4.73181Z",
    fill: "url(#paint11_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.624 15.1979H114.536L116.19 4.94547H119.278L117.624 15.1979ZM119.976 1.87168C119.976 2.4164 119.81 2.86385 119.478 3.21403C119.146 3.5642 118.634 3.73929 117.943 3.73929C116.934 3.73929 116.429 3.30481 116.429 2.43585C116.429 1.89113 116.595 1.44368 116.927 1.09351C117.259 0.743324 117.77 0.568237 118.461 0.568237C119.471 0.568237 119.976 1.00272 119.976 1.87168Z",
    fill: "url(#paint12_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.107 4.94556L129.433 15.198H127.002L127.081 13.0191C125.979 14.6143 124.564 15.412 122.836 15.412C121.907 15.412 121.209 15.1591 120.744 14.6533C120.279 14.1474 120.046 13.473 120.046 12.63C120.046 12.2799 120.073 11.9686 120.126 11.6962L121.242 4.94556H124.332L123.355 10.9375C123.315 11.132 123.295 11.3396 123.295 11.56C123.295 12.3253 123.574 12.7078 124.132 12.7078C124.571 12.7078 125.062 12.4679 125.607 11.988C126.152 11.5082 126.663 10.905 127.141 10.1788L127.999 4.94556H131.107Z",
    fill: "url(#paint13_radial_133_6411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21 4.73181C147.14 4.73181 147.838 4.98471 148.303 5.49053C148.768 5.99634 149 6.67076 149 7.5138C149 7.86399 148.974 8.17526 148.92 8.44762L147.804 15.1982H144.715L145.692 9.20631C145.732 9.01177 145.752 8.80428 145.752 8.58377C145.752 7.81853 145.473 7.43599 144.915 7.43599C144.144 7.43599 143.208 8.2725 142.105 9.94559L141.248 15.1982H138.159L139.135 9.20631C139.176 9.01177 139.195 8.80428 139.195 8.58377C139.195 7.81853 138.916 7.43599 138.358 7.43599C137.588 7.43599 136.644 8.27897 135.528 9.965L134.671 15.1982H131.562L133.237 4.94581H135.668L135.568 7.1247C136.126 6.32058 136.717 5.72398 137.342 5.3349C137.98 4.93284 138.75 4.73181 139.654 4.73181C141.208 4.73181 142.118 5.4192 142.384 6.79397C143.394 5.4192 144.669 4.73181 146.21 4.73181Z",
    fill: "url(#paint14_radial_133_6411)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_6411",
    x1: 6.42997,
    y1: 0.794674,
    x2: 14.0164,
    y2: 8.53846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0411,
    stopColor: "#FBED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FBED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#FFE400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8126,
    stopColor: "#F0A82E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_133_6411",
    x1: 7.25575,
    y1: 14.7028,
    x2: 14.856,
    y2: 6.94485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#F0A82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    stopColor: "#FFE400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7273,
    stopColor: "#FBED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9589,
    stopColor: "#FBED23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_133_6411",
    x1: 0.752492,
    y1: 7.89918,
    x2: 8.3263,
    y2: 15.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#F0A82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    stopColor: "#FFE400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7273,
    stopColor: "#FBED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9589,
    stopColor: "#FBED23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_133_6411",
    x1: -0.0414498,
    y1: 9.15508,
    x2: 7.54045,
    y2: 1.41596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0411,
    stopColor: "#FBED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FBED23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#FFE400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8126,
    stopColor: "#F0A82E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8705 12.5816) rotate(-147.825) scale(31.1295 446.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8706 12.5815) rotate(-147.825) scale(31.1295 446.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8707 12.5816) rotate(-147.825) scale(31.1295 446.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8706 12.5815) rotate(-147.825) scale(31.1295 446.121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8624 12.5775) rotate(-162.838) scale(56.2499 504.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8624 12.5778) rotate(-162.838) scale(56.2499 504.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8625 12.5777) rotate(-162.838) scale(56.2499 504.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8623 12.5778) rotate(-162.838) scale(56.2499 504.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8625 12.5774) rotate(-162.838) scale(56.2499 504.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8625 12.5776) rotate(-162.838) scale(56.2499 504.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_133_6411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8624 12.5778) rotate(-162.838) scale(56.2499 504.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_6411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 16,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlipkartPremium, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flipkartPremium.a10760d8.svg";
export { ForwardRef as ReactComponent };